import { render, staticRenderFns } from "./ExamEditor.vue?vue&type=template&id=4b10dc0a&"
import script from "./ExamEditor.vue?vue&type=script&lang=js&"
export * from "./ExamEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports